/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["popular-genres .genres .genre{position:relative}popular-genres .genres .genre:hover img{-webkit-filter:brightness(.4);filter:brightness(.4)}popular-genres .genres .genre .ng-lazyloaded{-webkit-filter:brightness(.3);filter:brightness(.3)}popular-genres .genres .genre .name{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);text-transform:capitalize;font-size:2rem;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}"];
export { styles as styles };
